import { execute } from "./common";
import { select } from "redux-saga/effects";
import { RootState } from "@/infrastructure/rootState";
import { AnomalAction } from "@/features/anomalies";
import { TradeAction } from "@/features/trades";

export default function*() {
  const country = yield select((state: RootState) => state.anomal.screener.setup.country);

  yield execute(
    [AnomalAction.fetchScreenerMetaAsync.request(country)],
    state => state.anomal.loading.meta === "SUCCESS"
  );

  yield execute([TradeAction.fetchTradeMeta.request()], state => state.trade.status.meta === "SUCCESS");
}
